import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { idSelector } from '../../../selectors/hostSelectors';
import HostDetail from './HostDetail';
import Hostnames from './Hostnames';

const HostnamesView = (props) => {
  const {
    hostId,
  } = props;

  if (hostId) {
    return (
      <HostDetail />
    );
  }

  return (
    <div className="resources-view">
      <Hostnames />
    </div>
  );
};

HostnamesView.propTypes = {
  hostId: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string,
  ]),
};

HostnamesView.defaultProps = {
  hostId: '',
};

const mapStateToProps = (state) => {
  const hostId = idSelector(state);

  return ({
    hostId,
  });
};

export default connect(mapStateToProps, null)(HostnamesView);
